(function() {
  var ConfirmationRow,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ConfirmationRow = App.loadClass('grower::Angular/Data/Add/Maps/Upload/Conversion/ConfirmationRow');

  exports.ConfirmationPlantingController = (function(superClass) {
    var alphabeticalComparison;

    extend(ConfirmationPlantingController, superClass);

    function ConfirmationPlantingController(scope, transitions, state, generate, data, loader, window, modal) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.generate = generate;
      this.data = data;
      this.loader = loader;
      this.window = window;
      this.modal = modal;
      this.confirm = bind(this.confirm, this);
      this.validateConfirmByStatus = bind(this.validateConfirmByStatus, this);
      this.validateProductSelection = bind(this.validateProductSelection, this);
      this.checkSelectionsForConfirm = bind(this.checkSelectionsForConfirm, this);
      this.loadParentData = bind(this.loadParentData, this);
      this.loadSelectData = bind(this.loadSelectData, this);
      this.openSurveyDialog = bind(this.openSurveyDialog, this);
      ConfirmationPlantingController.__super__.constructor.call(this, this.scope, this.transitions, this.state, this.generate, this.data, this.loader, this.window, this.modal);
      this.scope.resize = 0;
      this.scope.tab = 'planting';
      this.loadSelectData();
      this.scope.show_ingredion_column = false;
      this.scope.required_col_span = 4;
      this.scope.updateChildrenYear = this.updateChildrenYear;
      this.scope.updateChildrenCrop = this.updateChildrenCrop;
      this.scope.getSeedCompaniesByCrop = this.getSeedCompaniesByCrop;
      this.scope.updateChildrenNumberOfProducts = this.updateChildrenNumberOfProducts;
      this.scope.updateChildrenSeedCompanies = this.updateChildrenSeedCompanies;
      this.scope.updateChildrenProduct = this.updateChildrenProduct;
      this.scope.getProductsBySeedCompany = this.getProductsBySeedCompany;
      this.scope.clearCompanySelections = this.clearCompanySelections;
      this.scope.clearProductSelection = this.clearCompanySelections;
      this.scope.validateConfirmByStatus = this.validateConfirmByStatus;
      this.scope.checkSelectionsForConfirm = this.checkSelectionsForConfirm;
      this.scope.confirm = this.confirm;
      this.scope.openSurveyDialog = this.openSurveyDialog;
      this.scope.launchAddProduct = this.launchAddProduct;
      this.scope.groupProducts = this.groupProducts;
      this.scope.paginate = this.paginate;
    }

    ConfirmationPlantingController.prototype.openSurveyDialog = function(parent) {
      var dialog;
      dialog = this.modal.open({
        windowClass: 'large_dialog',
        templateUrl: 'backend/grower/maps-conversion/ingredion-survey',
        controller: 'MapsUpload.Controllers.IngredionDialogController',
        resolve: {
          survey: function() {
            return parent.data.reference.ingredion_survey;
          }
        }
      });
      return dialog.result.then((function(_this) {
        return function(answered_survey) {
          parent.data.reference.ingredion_survey = answered_survey;
          return _this.checkSelectionsForConfirm(parent);
        };
      })(this));
    };

    alphabeticalComparison = function(a, b) {
      var result;
      if (a.data.status === 'Reconfirm') {
        return -1;
      }
      if (b.data.status === 'Reconfirm') {
        return 1;
      }
      result = strnatcasecmp(a.data.status, b.data.status);
      if (result === 0) {
        result = strnatcasecmp(a.data.reference.farmName, b.data.reference.farmName);
      }
      if (result === 0) {
        result = strnatcasecmp(a.data.reference.fieldName, b.data.reference.fieldName);
      }
      if (result === 0) {
        result = strnatcasecmp(a.data.selected.year, b.data.selected.year);
      }
      return result;
    };

    ConfirmationPlantingController.prototype.loadSelectData = function() {
      this.data.getAllYears().then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope.years = response.data.data;
          }
        };
      })(this));
      return this.data.getCrops().then((function(_this) {
        return function(response) {
          var ref, ref1;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            return _this.scope.crops = response.data.data;
          }
        };
      })(this));
    };

    ConfirmationPlantingController.prototype.loadParentData = function(skip, take) {
      if (skip == null) {
        skip = 0;
      }
      if (take == null) {
        take = 10;
      }
      this.loader.overMap('Loading...');
      return this.data.getPlantingRows(skip, take).then((function(_this) {
        return function(response) {
          var i, j, len, len1, parent, product, ref, ref1, ref2, ref3;
          if ((response != null ? (ref = response.data) != null ? (ref1 = ref.status) != null ? ref1.type : void 0 : void 0 : void 0) === 'success') {
            _this.scope.parents = response.data.data.rows;
            ref2 = _this.scope.parents;
            for (i = 0, len = ref2.length; i < len; i++) {
              parent = ref2[i];
              parent.loading = false;
              if (parent.data.status === 'Processed') {
                parent.data.status = 'Done';
              }
              if (parent.data.reference.is_ingredion_field === true) {
                _this.scope.show_ingredion_column = true;
                _this.scope.required_col_span = 5;
              }
              ref3 = parent.data.fileData;
              for (j = 0, len1 = ref3.length; j < len1; j++) {
                product = ref3[j];
                if (product.selected.crop.id) {
                  _this.scope.getSeedCompaniesByCrop(product, product.selected.crop, false);
                }
                if (product.selected.seedCompany.id) {
                  _this.scope.getProductsBySeedCompany(product, false);
                }
                _this.checkSelectionsForConfirm(parent);
              }
            }
            _this.scope.parents.sort(alphabeticalComparison.bind([]));
            return response.data.data.count;
          }
        };
      })(this));
    };

    ConfirmationPlantingController.prototype.checkSelectionsForConfirm = function(parent) {
      var has_corn, i, j, len, len1, product, ref, ref1, ref2;
      parent.disabled.confirm = true;
      parent.disabled.ingredion = true;
      parent.show_ingredion = false;
      has_corn = false;
      if (parent.data.reference.is_ingredion_field === true) {
        ref = parent.data.fileData;
        for (i = 0, len = ref.length; i < len; i++) {
          product = ref[i];
          if (has_corn) {
            break;
          }
          has_corn = (product.selected.crop != null) && product.selected.crop.name === 'Corn';
        }
        if (has_corn) {
          parent.show_ingredion = true;
        }
      }
      if (parent.data.selected.year == null) {
        parent.disabled.confirm = true;
        return this.determineStatus(parent);
      }
      ref1 = parent.data.fileData;
      for (j = 0, len1 = ref1.length; j < len1; j++) {
        product = ref1[j];
        if (false === (((ref2 = product.selected.crop) != null ? ref2.id : void 0) != null) || false === this.validateProductSelection(product)) {
          parent.disabled.confirm = true;
          return this.determineStatus(parent);
        }
      }
      parent.disabled.ingredion = false;
      if (parent.data.reference.is_ingredion_field && parent.data.reference.ingredion_survey.for_ingredion === null) {
        return this.determineStatus(parent);
      }
      return this.determineStatus(parent).then((function(_this) {
        return function() {
          if (_this.validateConfirmByStatus(parent)) {
            return parent.disabled.confirm = false;
          }
        };
      })(this));
    };

    ConfirmationPlantingController.prototype.validateProductSelection = function(product) {
      var ref, ref1;
      return (((ref = product.selected.seedCompany) != null ? ref.id : void 0) != null) && (((ref1 = product.selected.product) != null ? ref1.id : void 0) != null);
    };

    ConfirmationPlantingController.prototype.validateConfirmByStatus = function(parent) {
      var ref;
      if ((ref = parent.data.status) === 'Processing' || ref === 'Failed' || ref === 'Done') {
        parent.disabled.confirm = true;
        return false;
      }
      return true;
    };

    ConfirmationPlantingController.prototype.confirm = function(parent) {
      parent.data.status = 'Processing';
      parent.loading = true;
      parent.disabled.confirm = true;
      return this.generate.confirm(parent.parent_id, parent.data.reference.ingredion_survey).then((function(_this) {
        return function(response) {
          return _this.updateTab();
        };
      })(this));
    };

    return ConfirmationPlantingController;

  })(ConfirmationRow);

}).call(this);
